export { Warehouse1DialogComponent } from './warehouse1-dialog.component';
export { Warehouse1Component } from './warehouse1.component';
